import React from 'react'
import classNames from 'classnames/bind'

import CatalogListItem from '../CatalogListItem'
import PromotionBanner from '../PromotionBanner'
import styles from './CatalogListGrid.module.css'
import { ICatalog } from 'types/Catalog'
import { GetCatalogsForShopPage_marketplaceCatalogs_nodes } from '../../pages/CatalogListPage/graphql/__generated__/GetCatalogsForShopPage'
import { GetCurrentPromotions_currentPromotions_slots_nodes } from '../../pages/CatalogListPage/graphql/__generated__/GetCurrentPromotions'

const cx = classNames.bind(styles)

type CatalogListGridProps = {
  className?: string
  catalogs: GetCatalogsForShopPage_marketplaceCatalogs_nodes[] | ICatalog[]
  promotionSlot?: GetCurrentPromotions_currentPromotions_slots_nodes
  // TODO: remove these unused props that the seller page and your catalogs page provide
  isCentered?: boolean
  title?: string
  showDepartmentLinks?: boolean
}

const CatalogListGrid = ({ className, catalogs, promotionSlot, showDepartmentLinks = true }: CatalogListGridProps) => {
  return (
    <div className={cx(className, styles.catalogListSection)}>
      {promotionSlot && <PromotionBanner promotionSlot={promotionSlot} />}
      <div className={styles.catalogListContainer}>
        {catalogs.map(catalog => (
          <CatalogListItem key={`catalog-${catalog.id}`} catalog={catalog} showDepartmentLinks={showDepartmentLinks} />
        ))}
      </div>
    </div>
  )
}

export default CatalogListGrid
